export function safeGetJson<T>(key: string, fallback: T): T {
  if (typeof window === 'undefined') return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function safeSetJson<T>(key: string, value: T): boolean {
  if (typeof window === 'undefined') return false;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function safeRemove(key: string): boolean {
  if (typeof window === 'undefined') return false;
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function safeGetString(key: string, fallback: string): string {
  if (typeof window === 'undefined') return fallback;
  try {
    return window.localStorage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
}

export function safeSetString(key: string, value: string): boolean {
  if (typeof window === 'undefined') return false;
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function generateId(prefix: string): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function loadWithSeed<T>(key: string, fallback: T, seed: T): T {
  if (typeof window === 'undefined') return fallback;
  const existing = safeGetJson<T | null>(key, null);
  if (existing !== null) return existing;
  safeSetJson(key, seed);
  return seed;
}

export function saveWithLimit<T>(key: string, value: readonly T[], maxItems: number, sortFn?: (a: T, b: T) => number): void {
  if (typeof window === 'undefined') return;
  const limited = sortFn ? [...value].sort(sortFn).slice(0, maxItems) : value.slice(0, maxItems);
  safeSetJson(key, limited);
}
